import React from "react";

interface Props {
  label: string;
}

const PassageSeparator = React.memo(({ label }: Props) => {
  return (
    <div className="flex m-3 items-center">
      <div className="flex-grow border-t border-slate-400"></div>
      <span className="flex-shrink mx-5 text-slate-400">{label}</span>
      <div className="flex-grow border-t border-slate-400"></div>
    </div>
  );
});

export default PassageSeparator;
